// NPM
import React, { useState, useEffect } from 'react'
import _ from 'lodash'

// Components
import Post from './Post'
import Tweet from './Tweet'

// Constants
const perPage = 6.0

const Updates = ({ sections, posts, tweets }) => {
  const [currentPage, setCurrentPage] = useState(0)
  const [currentFilter, setCurrentFilter] = useState("all")

  const featuredPost = posts.find(p => p.featured)
  let allUpdates = []

  if(currentFilter === "all") {
    allUpdates = [
      ...posts
      .filter(p => !p.featured)
      .map(p => ({ type: "Post", content: p, publishedOn: p.publishedOn })),

      ...tweets
      .map(t => ({ type: "Tweet", content: t, publishedOn: t.tweetDate }))
    ]
  }
  else if(currentFilter === "posts") {
    allUpdates = [
      ...posts
      .filter(p => !p.featured)
      .map(p => ({ type: "Post", content: p, publishedOn: p.publishedOn }))
    ]
  }

  allUpdates = _.sortBy(allUpdates, "publishedOn")

  let visibleUpdates = _.reverse(allUpdates)
  const numPages = Math.ceil(allUpdates.length / perPage)
  visibleUpdates = _.slice(visibleUpdates, 0, (currentPage * perPage) + perPage)

  const filtersSection = sections.find(s => s.uuid === "updates_filters")
  const miscTextSection = sections.find(s => s.uuid === "updates_miscText")
  let postLinkText = "Read story"
  let tweetLinkText = "See post"
  let loadMoreText = "Load more"

  if(miscTextSection) {
    postLinkText = (miscTextSection.miscText.find(mt => mt.uuid === "buttonText_postLink") || {}).text
    tweetLinkText = (miscTextSection.miscText.find(mt => mt.uuid === "buttonText_tweetLink") || {}).text
    loadMoreText = (miscTextSection.miscText.find(mt => mt.uuid === "buttonText_loadMore") || {}).text
  }

  return (
    <div className="Updates">
      { 
        filtersSection &&
          <div className="Updates__filters">
            { 
              _.get(filtersSection, 'miscText', []).map(mt => {
                return (
                  <button
                    className="Updates__filters-button"
                    onClick={ () => setCurrentFilter(mt.uuid) }>
                      <span>{ mt.text }</span>
                      <span className={ `Updates__filters-button-underline ${ mt.uuid === currentFilter ? "active" : "" }` }></span>
                  </button>
                )
              })
            }
          </div>
      }
      <div className="Updates__items">
        { 
          featuredPost && 
            <Post 
              post={ featuredPost } 
              isFeatured={ true } 
              linkText={ postLinkText} 
            />
        }
        {
          visibleUpdates.map((update, updateIndex) => {
            switch(update.type) {
              case "Post":
                return (
                  <Post 
                    key={ `update-${ updateIndex }` } 
                    post={ update.content }
                    linkText={ postLinkText }
                  />
                )

              case "Tweet":
                return (
                  <Tweet 
                    key={ `update-${ updateIndex }` } 
                    tweet={ update.content }
                    linkText={ tweetLinkText }
                  />
                )

              default: 
                return null
            }
          })
        } 
      </div>
      {
        currentPage < numPages  &&
          <div className="Updates__loadMore-holder">
            <button
              className="Updates__loadMore"
              onClick={ () => setCurrentPage(currentPage + 1) }>
                { loadMoreText }
            </button>
          </div>
      }
    </div>
  )

}

export default Updates